module.exports = "/packs/media/images/ManagingInvestment-ae2f7507ef352cb46b83039d03db81cb.png";